import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStickButton = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m37.5 8.75 12.498 12.5L62.5 8.75zM14.176 27.5c-3.41-.002-9.177 6.156-9.176 13.752 0 7.594 5.766 13.75 9.176 13.748h12v27.5h47.648V55h12c3.41.002 9.175-6.154 9.176-13.748 0-7.596-5.765-13.754-9.176-13.752z" })
});
export default SvgStickButton;
